// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'core-js/es6/promise'
import 'core-js/es6/string'
import 'core-js/es7/array'
// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import VueSpinners from 'vue-spinners'
import vSelect from 'vue-select'
import BlockUI from 'vue-blockui'
import Notify from 'vue2-notify'
import  VueColor from 'vue-color'
import * as format from 'date-fns/format/index';
import * as differenceInHours from 'date-fns/difference_in_hours/index';

import {env, colorPick} from './shared/variabel';

//import {GaleriesModal} from './views/galery/GaleriesModal';

Vue.prototype.setting = env;
Vue.prototype.end_point = env.end_point;
Vue.use(BlockUI)
Vue.use(BootstrapVue)
Vue.use(VueSpinners)
Vue.use(VueColor);
Vue.component('v-select', vSelect)
Vue.component('colorpicker',colorPick);
//Vue.component('GaleriesModal',GaleriesModal);
Vue.use(Notify,{
  position:'top-right',
  visibility: 5000, 
});

Vue.filter('toDateFormat', function (value) {
  if(!value){
    return '';
  }
  let dateLeft = new Date();
  let dateRight = new Date(value);
  let difH = differenceInHours(dateLeft, dateRight);
  return `${format(value,'DD/MM/YY HH:mm')}`;
});

window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.interceptors.request.use(
    (config) => {
      let token = window.sessionStorage.getItem(env.user_local_);
      if (token) {
        token = JSON.parse(token);
        config.headers['Token'] = `${ token.token }`;
      }  
      return config;
    }, 
    (error) => {
      return Promise.reject(error);
    }
);


window.axios.interceptors.response.use(
  (response) =>{
    
    console.log(response);
    if(response.data.error_code === '401'){
      // alert();
      Vue.$notify('youre sesion has been expired, goto login', 'error');
      window.sessionStorage.removeItem(env.user_local_);
      let dt = window.location.href;
      if(dt.indexOf('auth') <0) {
        window.location.assign('auth/login');
      }
      //window.location.assign('auth/login');
      ;
      return {};
    }
    return response
  },
  (error) => {
    this.$emit('errorMsg',error.message);
    if (error.response.status === 401) {
      //window.sessionStorage.removeItem('user_aresplanner');
      //window.location.reload();
    }
  }
);

let token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: {
    App
  },
  methods: {
    errorMsg(message) { 
      this.$notify.error(message);
    }
  }
})
